import { useEffect } from 'react';

import { useLoadingStore } from '~/store';

const GlobalSuspenseFallback = () => {
  const setLoading = useLoadingStore((state) => state.actions.setLoading);

  useEffect(() => {
    setLoading({ show: true, dimmed: false, zIndex: 1000 });

    return () => {
      setLoading({ show: false });
    };
  }, []);

  return <></>;
};

export default GlobalSuspenseFallback;
